function USANDApage() {
  return (
    <>
      <div className="flex items-center gap-2 mb-6">
        <span className="w-4 h-4 rounded-full bg-sky-300 flex-shrink-0"></span>
        <h3 className="text-lg font-bold text-[#05326D]">
          1. US ANDA – Abbreviated New Drug Application
        </h3>
      </div>

      <p className="text-md font-bold text-[#05326D] mb-4">
        Region: United States
      </p>
      <p className="text-[#05326D] mt-2">Purpose: Approval of generic drugs Regulatory </p>

      <p className="text-[#05326D] mb-4 mt-2">Body: US FDA (CDER)</p>


      <p className="text-md font-bold text-[#05326D] mb-4">
        Key Components:
      </p>
      <p className="ml-2 mt-2 text-[#05326D]">- Module 1–5 in CTD format</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Bioequivalence studies</p>
      <p className="ml-2 mt-2 text-[#05326D]">- DMF references (Type II, III, IV)</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Labeling and packaging compliance</p>
      <p className="ml-2 mt-2 text-[#05326D]">- GDUFA cover sheet and self-identification</p>

      <p className="text-md font-bold text-[#05326D] mb-4 mt-4">
        Filing Notes: </p>

      <p className="ml-2 mt-2 text-[#05326D]">- Submitted via FDA ESG portal in eCTD format</p>
      <p className="ml-2 mt-2 text-[#05326D]">- DMFs must be pre-assigned and technically validated</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Lifecycle includes annual updates, amendments, and query responses</p>



      <hr className="border-t border-gray-300 mb-8 mt-8" />
      <p className="text-md font-bold text-[#05326D] mb-4 mt-4">
        Strategic Tip from FDAC: </p>

      <p className="text-[#05326D]">For global dossier success, FDAC recommends:</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Early alignment of DMF/ASMF/CEP with target market requirements</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Robust eCTD publishing and validation workflows</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Lifecycle planning for post-approval changes and renewals</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Cloud-based collaboration for real-time dossier management</p>
    </>

  );
}

export default USANDApage;
